import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';

import { Activate } from './activate.service';

@Component({
    selector: 'jhi-activate',
    templateUrl: './activate.component.html'
})
export class ActivateComponent implements OnInit {
    error: string;
    success: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private activate: Activate,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.jhiLanguageService.setLocations(['activate', 'global']);
    }

    ngOnInit () {
        this.route.queryParams.subscribe(params => {
            this.activate.get(params['key']).subscribe(() => {
                this.error = null;
                this.success = 'OK';
            }, (error) => {
                this.success = null;
                this.error = 'ERROR';
            });
        });
    }

    login() {
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate.component.ts